export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILURE = 'FETCH_USERS_FAILURE';

export const CHECK_USER_SUCCESS = 'CHECK_USER_SUCCESS';
export const CHECK_USER_FAILURE = 'CHECK_USER_FAILURE';

export const FETCH_USER_METADATA_STARTED = 'FETCH_USER_METADATA_STARTED';
export const FETCH_USER_METADATA_SUCCESS = 'FETCH_USER_METADATA_SUCCESS';
export const FETCH_USER_METADATA_FAILURE = 'FETCH_USER_METADATA_FAILURE';

export const UPDATE_USER_METADATA_STARTED = 'UPDATE_USER_METADATA_STARTED';
export const UPDATE_USER_METADATA_SUCCESS = 'UPDATE_USER_METADATA_SUCCESS';
export const UPDATE_USER_METADATA_FAILURE = 'UPDATE_USER_METADATA_FAILURE';
